<template>
  <el-main>
    <el-form :model="ruleForm" ref="ruleForm" status-icon :rules="rules" label-width="120px">
      <el-form-item label="主推商品：" prop="main_push_goods">
        <div>
          <vuedraggable
            v-bind="{
              animation: 200,
              group: 'description',
              disabled: false,
              ghostClass: 'ghost',
              scroll: true,
            }"
          >
            <transition-group>
              <div class="itemBox mb20" v-for="(item, index) in ruleForm.main_push_goods" :key="index">
                <el-input disabled v-model="item.goods_name"></el-input>
                <el-button type="primary" @click="ShowGoodsDialog(index)">选择</el-button>
                <img
                  class="closeImg"
                  @click="delItem('main_push_goods', index)"
                  v-if="ruleForm.main_push_goods.length > 1"
                  src="https://boweisou.oss-cn-shenzhen.aliyuncs.com/enterpriseShop/close.png"
                  alt=""
                />
              </div>
            </transition-group>
          </vuedraggable>
          <div>
            <el-button type="text" @click="clickAdd('main_push_goods')">+ 添加主推商品</el-button>
            <span class="tips">仅支持六个商品</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <!-- 选择商品弹框 -->
    <el-dialog title="选择商品" :visible.sync="goodsDialog" width="52%">
      <div class="chooseShopBox">
        <div class="searchBox">
          <el-input v-model="goodsConfig.search" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" @click="searchOne">搜索</el-button>
        </div>
        <div class="showAllList" @scroll="loadPageMore">
          <div class="showAllItem" v-for="(item, index) in allGoodsList" :key="index">
            <div class="info">
              <img :src="item.goods_picture" alt="" />
              <div>{{ item.goods_name }}</div>
            </div>
            <div>￥{{ item.goods_price }}</div>
            <el-button type="text" @click="chooseGoods(item)">选择</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <Preservation @preservation="Preservation"></Preservation>
  </el-main>
</template>

<script>
import vuedraggable from 'vuedraggable';
import Preservation from '@/components/preservation';
export default {
  components:{
      Preservation,
      vuedraggable
  },
  data() {
    function mainCheck(rule, value, callback) {
      let flag = true;
      for (let i = 0; i < value.length; i++) {
        if (!value[i].id) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        callback(new Error('请选择主推商品'));
      } else {
        callback();
      }
    }
    return {
      ruleForm: {
        main_push_goods: [{}],
      },
      rules: {
        main_push_goods: [{ required: true, validator: mainCheck, trigger: 'change' }],
      },
      goodsDialog: !1,
      allGoodsList: [],
      list:[],
      chooseIndex: -1,
      goodsConfig: {
        search: '',
        page: 1,
        rows: 10,
        total: 0,
      },
      type: 'main_push_goods',
    };
  },
  created(){
    this.getRecommendGoods();
  },
  methods: {
    getRecommendGoods(){
        this.$axios.post(this.$api.en.recommendGoodsInfo).then(res=>{
            if(res.code == 0){
                if(res.result){
                    this.ruleForm.main_push_goods = res.result;
                }
            }
        })
    },
    getGoodsList() {
      let obj = {
        page: this.goodsConfig.page,
        rows: this.goodsConfig.rows,
        status: 1,
      };
      if (this.goodsConfig.search) obj.goods_name = this.goodsConfig.search;
      this.$axios.post(this.$api.goods.list, obj).then((res) => {
        if (res.code == 0) {
          this.allGoodsList = this.allGoodsList.concat(res.result.list);
          this.goodsConfig.total = res.result.total_number;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    chooseGoods(data) {
      this.ruleForm.main_push_goods[this.chooseIndex] = data;
      this.goodsDialog = false;
    },
    loadPageMore(e) {
      if (e.currentTarget.scrollTop + e.currentTarget.clientHeight >= e.currentTarget.scrollHeight) {
        // 业务逻辑...
        if (this.goodsConfig.total / this.goodsConfig.rows > this.goodsConfig.page) {
          this.goodsConfig.page++;
          this.getGoodsList();
        }
      }
    },
    clickAdd(type) {
      if (type === 'main_push_goods' && this.ruleForm[type].length == 6) {
        this.$message.warning('已到最大推荐数');
        return;
      }
      this.ruleForm[type].push({});
    },
    ShowGoodsDialog(index) {
      this.goodsConfig = {
        search: '',
        page: 1,
        rows: 10,
        total: 0,
      };
      this.getGoodsList();
      this.chooseIndex = index;
      this.goodsDialog = true;
    },
    delItem(type, index) {
      this.ruleForm[type].splice(index, 1);
    },
     Preservation() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let id = [];
          this.ruleForm.main_push_goods.map(item=> id.push(item.id))
          this.$axios.post(this.$api.en.editRecommendGoods, {
              value:id
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('设置成功');
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
   min-height: 100%;
  padding-bottom: 80px;
  .mb20 {
    margin-bottom: 20px;
  }
  .tips {
    color: #9f9f9f;
    font-size: 12px;
    margin-left: 20px;
  }
  .el-form {
    .itemBox {
      &:last-child {
        margin-bottom: 0;
      }
      display: flex;
      align-items: center;
      .el-input {
        width: 400px;
      }

      .closeImg {
        width: 20px;
        height: 20px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .chooseShopBox {
    .searchBox {
      display: flex;
      align-items: center;
    }
    .showAllList {
      height: 390px;
      width: 100%;
      overflow-y: auto;
      margin-top: 20px;
      .showAllItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 20px;
        margin: 6px 0;
        .info {
          display: flex;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            margin-right: 20px;
          }
          div {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .showAllItem:hover {
        background-color: #faf5f5ef;
      }
    }
  }
}
</style> 